import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { LogoState } from '@shared/states/logo.state';

export const LogoStateResolver: ResolveFn<void> = (): Observable<void> => {
  return inject(LogoState).loadLogos();
};
